export default {"src":"/_next/static/media/WeeklySipStatus.c1b61300.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};